var map = {
	"./Albanija.png": "9b6b",
	"./Anglija.png": "d6bf",
	"./Balearski otoki.png": "6bf9",
	"./Bolgarija.png": "3a94",
	"./Bosna in Hercegovina.png": "2163",
	"./Ciper.png": "7ca5",
	"./Danska.png": "7285",
	"./Egipt.png": "3461",
	"./Estonija.png": "33fb",
	"./Finska.png": "0ffc",
	"./Francija.png": "c8dd",
	"./Gibraltar.png": "dada",
	"./Grčija.png": "d679",
	"./Hrvaška.png": "1ff3",
	"./Italija.png": "ffd9",
	"./Kanarski otoki.png": "5694",
	"./Korzika.png": "75c6",
	"./Kosovo.png": "8e4d",
	"./Latvija.png": "6712",
	"./Lihtenštajn.png": "1dda",
	"./Litva.png": "c271",
	"./Madeira.png": "d9bf",
	"./Madžarska.png": "7245",
	"./Malta.png": "e659",
	"./Maroko.png": "1259",
	"./Monaco.png": "512b",
	"./Nemčija.png": "a7e3",
	"./Nizozemska.png": "700e",
	"./Norveška.png": "fc00",
	"./Poljska.png": "fdf1",
	"./Portugalska.png": "b289",
	"./Romunija.png": "fb95",
	"./Rusija.png": "c40c",
	"./Sardinija.png": "b55b",
	"./Severna Makedonija.png": "38e5",
	"./Sicilija.png": "04b5",
	"./Slovaška.png": "9110",
	"./Slovenija.png": "a582",
	"./Srbija.png": "7bf5",
	"./Turčija.png": "f54c",
	"./Združene države Amerike.png": "af45",
	"./Češka.png": "2533",
	"./Črna gora.png": "089b",
	"./Španija.png": "5e9e",
	"./Švica.png": "b77b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";